import {observable} from 'mobx';
import Celebration from './Celebration';

class Anniversary extends Celebration {
  @observable numberOfYears;
}

export default Anniversary;
